import React, { useState } from 'react';
import './OchelariDeSoare.css';

export default function OchelarideSoare() {
    const [callCount, setCallCount] = useState(0); // State pentru numărul de apeluri
    const phoneNumber = '+40 727 700 008'; // Numărul de telefon dorit

    const handleCallButtonClick = () => {
        setCallCount(callCount + 1); // Incrementăm numărul de apeluri
    };

    return (
        <div>
            <div className="hero-section position-relative">
                <img src="./Imagini/soarefront.jpg" className="hero-image img-fluid" alt="Ochelari de Soare" />
                <div className="overlay position-absolute w-100 h-100 d-flex flex-column justify-content-center align-items-center text-white">
                    <h1 className="main-title">OCHELARI DE SOARE</h1>
                    <h4 className="subtitle">Modele pentru stilul tău</h4>
                </div>
            </div>

            <div className="container text-center mb-5">
                <h1 className="mb-4">Colecția de Ochelari de Soare</h1>
                <p className="lead">Descoperă cele mai noi modele de ochelari de soare care îți completează stilul!</p>
            </div>

            <div className="container">
                <div className="row row-cols-1 row-cols-md-3 g-4">
                    <div className="col">
                        <div className="card product-card">
                            <img src="./imagini/pexels-nitin-dhumal-46710.jpg" className="card-img-top" alt="Ochelari de Soare 1" />
                            <div className="card-body">
                                <h5 className="card-title">Ochelari de Soare Aviator - Eleganță Clasică și Protecție Maximă</h5>
                                <p className="card-text">Descoperă ochelarii de soare Aviator - un clasic al eleganței și stilului, perfecți pentru orice ocazie. Cu rame metalice ușoare și lentile polarizate de înaltă calitate, acești ochelari oferă nu doar un aspect sofisticat, ci și protecție UV 100% împotriva razelor solare dăunătoare.

Designul lor atemporal se potrivește oricărui tip de față, iar lentilele polarizate reduc reflexiile, oferindu-ți claritate excepțională și confort vizual pe tot parcursul zilei. Fie că te afli la volan, te plimbi pe plajă sau ieși în oraș, ochelarii de soare Aviator adaugă o notă de rafinament oricărui stil.

Alege Aviator - alege calitatea, confortul și un look ce nu se demodează niciodată.

</p>
                                <a href="#" className="btn btn-primary">Vezi detalii</a>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card product-card">
                            <img src="./imagini/pexels-murray-official-255305.jpg" className="card-img-top" alt="Ochelari de Soare 2" />
                            <div className="card-body">
                                <h5 className="card-title">Ochelari de Soare Retro - Stil Clasic pentru Orice Ocazie</h5>
                                <p className="card-text">Adaugă un plus de eleganță și autenticitate look-ului tău cu ochelarii de soare Retro. Acești ochelari impresionează prin designul lor clasic, inspirat din moda anilor '60 și '70, fiind perfecți pentru cei care iubesc stilurile atemporale și îndrăznețe.

Ramele robuste și confortabile oferă o potrivire perfectă, iar lentilele polarizate de înaltă calitate asigură protecție UV completă, pentru a-ți proteja ochii în zilele însorite. Îmbrățișează un look vintage și ieși în evidență la orice eveniment cu un accesoriu care aduce farmecul clasic într-un context modern.

Cu ochelarii de soare Retro, autenticitatea și bunul gust sunt întotdeauna la modă!</p>
                                <a href="#" className="btn btn-primary">Vezi detalii</a>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card product-card">
                            <img src="./imagini/pexels-jonathan-oliveira-386410.jpg" className="card-img-top" alt="Ochelari de Soare 3" />
                            <div className="card-body">
                                <h5 className="card-title">Ochelari de Soare Sport - Flexibilitate și Protecție pentru Performanță</h5>
                                <p className="card-text">Îmbunătățește-ți performanțele și bucură-te de activitățile în aer liber cu ochelarii de soare Sport. Concepuți pentru a face față celor mai intense aventuri, acești ochelari oferă o combinație ideală de rame flexibile și lentile rezistente, care îți oferă confort și protecție maximă.

Cu un design ergonomic, ochelarii de soare Sport se potrivesc perfect, fiind potriviți pentru alergare, ciclism, drumeții și multe alte activități dinamice. Lentilele polarizate reduc reflexiile și oferă protecție UV 100%, protejându-ți ochii în orice condiții de lumină.

Rămâi activ, confortabil și în siguranță cu ochelarii de soare Sport - alegerea ideală pentru orice pasionat de mișcare!</p>
                                <a href="#" className="btn btn-primary">Vezi detalii</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container promo">
                <h3>Ofertă Specială: Reducere de 20% la toate modelele!</h3>
                <p>Profită de reducerile noastre și îmbunătățește-ți stilul cu noii ochelari de soare.</p>
                <div>
                    <h1>Contactează-ne</h1>
                    <p>Dacă ai nevoie de asistență, nu ezita să ne suni!</p>
                    <a 
                        href={`tel:${phoneNumber}`} 
                        className="call-button" 
                        onClick={handleCallButtonClick} // Apelează funcția la click
                    >
                        Sună-ne
                    </a>
                    {/* Afișează numărul de telefon sub buton */}
                    <p className="phone-number">{phoneNumber}</p>
                    {callCount > 0 && ( // Afișează numărul de apeluri
                        <p>Numărul de apeluri efectuate: {callCount}</p>
                    )}
                </div>
            </div>
        </div>
    );
}
